// GENERATED by scripts/legal.mjs from legal/config.toml and legal/docs/*.md.
// Not committed and never edited: change those files and run `npm run legal`.
import type { Legal } from './legal';

export const generatedLegal: Legal = {
  "published": true,
  "version": "1.0",
  "effectiveDate": "October 7, 2026",
  "entity": "KLOUD CONSULTING, Inc.",
  "documents": [
    {
      "slug": "terms",
      "title": "ClimbJobs Terms of Service",
      "description": "The agreement between you and us: what ClimbJobs is and is not, the rules for using it, and how prices, renewal, cancelling, credits and refunds work.",
      "path": "/terms"
    },
    {
      "slug": "privacy",
      "title": "ClimbJobs Privacy Policy",
      "description": "What we collect, why, who receives it, how long we keep it, and your choices.",
      "path": "/privacy"
    },
    {
      "slug": "auto-apply",
      "title": "ClimbJobs Auto-Apply Terms",
      "description": "What Auto-Apply sends in your name, the limits you set, and what stays your responsibility.",
      "path": "/auto-apply-terms"
    }
  ],
  "sections": [
    {
      "slug": "billing",
      "path": "/billing-terms",
      "to": "/terms#10-subscription-credits-and-refunds"
    }
  ]
};
